import React from 'react';
import { Col, Form, InputNumber, Row, Switch } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { FormattedMessage } from 'react-intl';
import { Configuration } from '../api/types';
import { Mode } from '../store/types';
import { transformFormData } from '../utils/DataManagement';

interface Props extends FormComponentProps<Configuration> {
  data: Configuration;
  mode: Mode;
}

export const dateFormat = 'YYYY-MM-DD';

const ConfigurationForm: React.FC<Props> = ({
  form: { getFieldDecorator },
  mode,
}) => {
  const isView = mode === Mode.VIEW;

  return (
    <Form
      labelCol={{ span: 10 }}
      wrapperCol={{ span: 14 }}
      className='pup-form'
    >
      <Row gutter={16}>
        <Col span={16}>
          <Form.Item
            label={
              <FormattedMessage id='configuration.form.discountVp' />
            }
          >
            {getFieldDecorator('discountVp', {
              rules: [
                {
                  required: !isView,
                  message: <FormattedMessage id='validations.required' />,
                },
              ],
            })(
              <InputNumber
                readOnly={isView}
                min={1}
                max={100}
                className='input-number-smaller'
              />,
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={16}>
          <Form.Item
            label={<FormattedMessage id='configuration.form.discountVpCalculation' />}
          >
            {getFieldDecorator('discountVpCalculation', {
              valuePropName: 'checked',
              rules: [
                {
                  required: !isView,
                  message: <FormattedMessage id='validations.required' />,
                },
              ],
            })(<Switch disabled={isView} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default Form.create<Props>({
  mapPropsToFields: ({ data }) => transformFormData(data),
})(ConfigurationForm);
